import React from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Step, Wrap } from "./StepIndicator.styled";

const getState = (index, activeIndex) => {
    if (index === activeIndex) return "active";
    return index < activeIndex ? "done" : "upcoming";
};

/**
 * "1 Choose source > 2 Configure" indicator. Completed steps are clickable
 * when `onStepClick` is provided.
 */
const StepIndicator = ({ steps, activeIndex, onStepClick }) => (
    <Wrap role="list" aria-label="Steps">
        {steps.map((label, index) => {
            const state = getState(index, activeIndex);
            const isClickable = state === "done" && Boolean(onStepClick);
            return (
                <React.Fragment key={label}>
                    {index > 0 && <ChevronRightIcon className="step-chevron" />}
                    <Step
                        role="listitem"
                        $state={state}
                        disabled={!isClickable}
                        disableRipple
                        aria-current={state === "active" ? "step" : undefined}
                        onClick={
                            isClickable ? () => onStepClick(index) : undefined
                        }
                    >
                        {state === "active" && <span className="step-dot" />}
                        {state === "done" && <CheckCircleIcon />}
                        <span>
                            {index + 1} {label}
                        </span>
                    </Step>
                </React.Fragment>
            );
        })}
    </Wrap>
);

export default StepIndicator;
